import React from 'react';

/** Visit Report footer — batch release Open DCFs to CRA (reviewer only). */
export default function SubmitAllDcfButton({
  visible,
  disabled,
  submitting,
  onClick,
}) {
  if (!visible) return null;
  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={onClick}
      disabled={disabled || submitting}
    >
      {submitting ? 'Submitting...' : "Submit All Reviewer's Comments"}
    </button>
  );
}
